import { useMemo } from 'react';

import { useGlobalFilterDataStore } from 'store/globalFilterData.store';

import { filterValueResolverByKey } from 'components/pages/ConfirmWidgetPage/components/ReportGlobalFilters/GlobalFiltersReportWrapper.utils';

export const useGetReportFilterValue = ({ defaultValues }) => {
    const { getValueFromStore } = useGlobalFilterDataStore();

    return useMemo(() => {
        let resolvedFilterValues: Record<string, any> = {};

        Object.keys(defaultValues).forEach((filterKey) => {
            const storeValue = getValueFromStore<string>(filterKey);

            if (!filterValueResolverByKey[filterKey]) {
                resolvedFilterValues[filterKey] = defaultValues[filterKey];
            } else {
                resolvedFilterValues[filterKey] = filterValueResolverByKey[filterKey]?.(
                    defaultValues[filterKey],
                    storeValue,
                );
            }
        });

        return resolvedFilterValues;
    }, [defaultValues, getValueFromStore, filterValueResolverByKey]);
};
